export enum TipoGuiaEnum {

  avulsa = "Avulsa",
  valorFixo = "Valor fixo",
  encerramento = "Encerramento",
  notaAvulsa = "Nota fiscal avulsa"
}
